<template>
    <div>
        <div :class="[`image-list-box-${boxHeight}`]">
            <component :is="isAttribute" :class="['gallery-card-image-title', 'pointer', {fullscreen: cover}]" v-bind:style="style"
                v-bind="linkAttributes" v-light-box="lightBox ? resolvedLink : false">
                <img v-if="!cover" :src="image" :alt="alt"/>
                <slot name="badge"></slot>
            </component>
            <div v-if="!hideActions" class="gallery-card-image-actions no-margin">
                <component :is="isAttribute" v-bind="linkAttributes" v-light-box="lightBox ? resolvedLink : false" class="gallery-card-image__filename pointer">
                    <span><slot name="title"></slot></span>
                    <br>
                    <span class="additional-information"><slot name="additional-information"></slot></span>
                </component>
                <slot name="buttons"></slot>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import {defineAsyncComponentWrapper} from '@/library/utils';
    import {Component, Prop, Vue} from 'vue-facing-decorator';
    import {type RouteLocationRaw} from 'vue-router';

    const ActionMenu = defineAsyncComponentWrapper(() => import('./ActionMenu.vue'));

    @Component({
        name: 'ImageListBox',
        components: {
            ActionMenu,
        },
    })
    export default class ImageListBox extends Vue
    {
        @Prop({
            type: String,
            default: '',
            required: false,
        }) image: string;

        @Prop({
            type: [Object, String],
            default: {},
            required: false,
        }) link: RouteLocationRaw | string;

        @Prop({
            type: String,
            default: 'low',
            required: false,
        }) boxHeight: 'low' | 'high';

        @Prop({
            type: String,
            default: '',
            required: false,
        }) alt: string;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) cover: boolean;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) lightBox: boolean;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) hideActions: boolean;

        get style()
        {
            if (this.cover)
            {
                return {
                    'background-image': `url(${this.image})`,
                };
            }

            return {};
        }

        get resolvedLink()
        {
            if ('string' === typeof this.link)
            {
                return this.link;
            }

            return this.$router.resolve(this.link).href;
        }

        get isAttribute()
        {
            if (!this.lightBox)
            {
                return 'router-link';
            }

            return 'a';
        }

        get linkAttributes()
        {
            if (!this.lightBox)
            {
                return {
                    to: this.link,
                };
            }

            return {
                href: this.resolvedLink,
            };
        }
    }
</script>